import utils from "../../../utils/utils.js";

export default {
    async fetchCaptchaImage(context) {
        const responseData = await utils.utility.fetch("api/auth/getcaptcha", "GET", null, null);

        context.commit("setCaptchaImage", responseData.data);
    }
}